import { useSearchParams } from '@remix-run/react';

/**
 * Extracts a post redirect URL from the `postSlug` search parameter.
 * Used on login pages to redirect back to the gated post after authentication.
 */
const usePostSlugRedirect = (): string | undefined => {
  const [searchParams] = useSearchParams();
  const postSlug = searchParams.get('postSlug');

  if (!postSlug || postSlug.trim() === '') {
    return undefined;
  }

  return `/p/${postSlug}`;
};

export default usePostSlugRedirect;
